import React, {useCallback, useContext} from 'react'

import {CameraIcon} from '../../icons'
import {Link} from '../../link'
import {ListItem} from '../list'
import {PassportContext} from './context'
import {useListItemStyles, useStyles} from './styles'
import {PassportUserData} from './types'

type Props = {
  item: PassportUserData
  isCurrent?: boolean
}

const UserItem: React.FC<Props> = ({item, isCurrent}) => {
  const {avatarHost, returnPath, passportHost, yui, cameraUrl, service} = useContext(PassportContext)
  const classes = useStyles()
  const formRef = React.useRef<HTMLFormElement | null>(null)

  const handleClick = useCallback(() => {
    if (formRef.current) {
      formRef.current.submit()
    }
  }, [])

  let decodedRetpath
  try {
    decodedRetpath = decodeURIComponent(returnPath)
  } catch (e) {
    decodedRetpath = returnPath
  }

  return (
    <ListItem
      classes={useListItemStyles({isCurrent})}
      endElement={
        <form ref={formRef} action={`${passportHost}/passport?mode=embeddedauth`} method="POST">
          <input name="yu" type="hidden" value={yui} />
          <input name="retpath" type="hidden" value={decodedRetpath} />
          <input name="uid" type="hidden" value={item.id} />
          <input name="action" type="hidden" value="change_default" />
        </form>
      }
      onClick={handleClick}
      startElement={
        <div className={classes.image}>
          <img
            alt=""
            className={classes.avatar}
            height="40"
            src={`${avatarHost}/get-yapic/${item.avatarId}/islands-middle`}
            srcSet={`${avatarHost}/get-yapic/${item.avatarId}/islands-middle 1x, ${avatarHost}/get-yapic/${item.avatarId}/islands-retina-middle 2x`}
            width="40"
          />
          {cameraUrl && isCurrent && (
            <Link className={classes.camera} href={`${cameraUrl}?origin=${service}&${returnPath}`}>
              <CameraIcon fontSize="inherit" />
            </Link>
          )}
        </div>
      }
      subtitle={item.email}
      title={item.login}
    />
  )
}

export default UserItem
